import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgUserLocation = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsxs("g", { id: "Group 4153", children: [
  /* @__PURE__ */ jsx("circle", { id: "Ellipse 30", cx: 16, cy: 16, r: 16, fill: "#2177DF", fillOpacity: 0.2 }),
  /* @__PURE__ */ jsxs("g", { id: "Group 4154", children: [
    /* @__PURE__ */ jsxs("g", { id: "Ellipse 32", children: [
      /* @__PURE__ */ jsx("circle", { cx: 16, cy: 16, r: 8, fill: "white" }),
      /* @__PURE__ */ jsx("circle", { cx: 16, cy: 16, r: 8.5, stroke: "black", strokeOpacity: 0.12 })
    ] }),
    /* @__PURE__ */ jsxs("g", { id: "Ellipse 29", children: [
      /* @__PURE__ */ jsx("circle", { cx: 16, cy: 16, r: 5, fill: "#2177DF" }),
      /* @__PURE__ */ jsx("circle", { cx: 16, cy: 16, r: 4.5, stroke: "black", strokeOpacity: 0.24 })
    ] })
  ] })
] }) });
const ForwardRef = forwardRef(SvgUserLocation);
export { ForwardRef as ReactComponent };
